<svg
    width="233"
    height="140"
    viewBox="0 0 233 140"
    xmlns="http://www.w3.org/2000/svg">
    <g
        app-roof
        [type]="type()"></g>

    <g
        [x]="40"
        [y]="-35"
        app-roof-box></g>

    <g
        [x]="-5"
        y="-5"
        app-roof-box></g>
</svg>